import React from 'react';
import produce from 'immer';
import { useSelector } from 'react-redux';

import { Text, CanAccess, WrapperFlex } from '@unimed-fesp/components';

import theme from '../../../styles/theme';

import { TipoPerfilUsuarioEnum } from '../../../enums';

// #region Importação Componentes
import FadeIn from '../../atoms/FadeIn';
import InputForm from '../../atoms/InputForm';
import InputFormLogin from '../../atoms/InputFormLogin';
import LabelContainer from '../../molecules/LabelContainer';
import SenhaBox from '../SenhaBox';
// #endregion

const DadosAcesso = ({
  usuarioParams,
  dadosAcessoParams,
  setDadosAcessoParams,
  usuarioDadosAcesso,
  handleAcaoUsuarioById,
  errorSenha,
  errorNovaSenha,
  errorConfirmacaoSenha,
}) => {
  const { usuario } = useSelector((state) => state.auth);
  function handleInput(e, status) {
    const newDadosAcessoParams = produce(dadosAcessoParams, (draft) => {
      if (draft[status] !== e.target.value) draft[status] = e.target.value;
    });

    setDadosAcessoParams(newDadosAcessoParams);
  }

  return (
    <WrapperFlex column justifyCenter alignCenter>
      <FadeIn>
        <WrapperFlex column justifyCenter alignStart>
          <Text
            font="bold 16px/14px Calibri"
            color={theme.greenDefault}
            text="Acesso"
            paddingBottom={20}
          />
          <LabelContainer text="Nome do usuário" marginBottom="30">
            <InputForm
              handleChange={(e) => handleInput(e, 'nome')}
              disabled
              marginTop="9"
              width="633"
              height="40"
              placeholder="Informe o nome completo do usuário"
              name="nome"
              value={usuarioParams.nome}
            />
          </LabelContainer>
          <CanAccess
            checkRole={{
              Adm: TipoPerfilUsuarioEnum.returnNameForName.Adm,
            }}
            userRole={usuario.role}
          >
            <LabelContainer text="E-mail do usuário" marginBottom="30">
              <InputFormLogin
                handleChange={(e) => handleInput(e, 'email')}
                disabled
                marginTop="9"
                width="458"
                height="40"
                placeholder="Informe o e-mail do usuário"
                name="email"
                value={dadosAcessoParams.email}
              />
            </LabelContainer>
          </CanAccess>
        </WrapperFlex>
        <SenhaBox
          params={dadosAcessoParams}
          setParams={setDadosAcessoParams}
          errorSenha={errorSenha}
          errorNovaSenha={errorNovaSenha}
          errorConfirmacaoSenha={errorConfirmacaoSenha}
          paddingRight="0"
          eyeWidth="auto"
        />
      </FadeIn>
    </WrapperFlex>
  );
};

export default DadosAcesso;
